import React, { useEffect, useState } from "react";

// api
import { getMomtheraDashboardPatientGroup, getMomtheraDashboardTraining } from "../../../services/apis/momthera/dashboard";

// component
import MomtheraCommonTable from "../../../components/momthera/table/MomtheraCommonTable";
import DashboardDoughnutChart from "../../../components/momthera/chart/dashboard/DashboardDoughnutChart";

const COLOR = {
    'EXP': '#92C254',
    'COMP': '#8ACDFB',
    'TESTER': '#FF867C',
    'COMMON': '#FFCC80'
}

function MomtheraDashboardPage() {
    // 어플 사용자
    const [userData, setUserData] = useState({
        TOTAL: 0,
        EXP: 0,
        COMP: 0,
        TESTER: 0,
        COMMON: 0
    });
    // 어플 사용 현황
    const [usageGraphData, setUsageGraphData] = useState([]);
    const [usageTableData, setUsageTableData] = useState([]);

    // 어플 사용자 조회
    async function getMomtheraDashboardPatientGroupFromAPI() {
        try {
            const res = await getMomtheraDashboardPatientGroup();
            if(Math.floor(res.status/100)===2){
                let totalCnt = 0;
                const newUserData = {...userData};
                res.data.forEach(e=> {
                    newUserData[e.code] = e.count;
                    totalCnt+=e.count;
                })
                newUserData.TOTAL = totalCnt;
                setUserData(newUserData);
            }else{
                throw new Error();
            }
        }catch{
            setUserData({
                TOTAL: 0,
                EXP: 0,
                COMP: 0,
                TESTER: 0,
                COMMON: 0
            })
        }
    }

    // 어플 사용 현황 조회
    async function getMomtheraDashboardTrainingFromAPI() {
        try {
            const res = await getMomtheraDashboardTraining();
            if(Math.floor(res.status/100)===2){
                let totalCnt = 0;
                const newUsageTableData = [];
                res.data.forEach(e=>{
                    newUsageTableData.push({
                        현황: e.name,
                        count: e.count,
                        percentage: `${e.rate}%`
                    })
                    totalCnt+=e.count;
                })
                newUsageTableData.push({
                    현황: '전체',
                    count: totalCnt,
                    percentage: '100%'
                })
                setUsageTableData(newUsageTableData);
                setUsageGraphData(res.data);
            }else{
                throw new Error();
            }
        }catch{
            setUsageTableData([]);
            setUsageGraphData([]);
        }
    }

    useEffect(()=>{
        getMomtheraDashboardPatientGroupFromAPI();
        getMomtheraDashboardTrainingFromAPI();
    },[])

    return (
        <div className="dashboardContent dtx006" style={{height: 'auto'}}>
            <div className="dashboardContent__title">
                <span className="dashboardContent__title__content">
                어플 사용자
                </span>
            </div>
            <div className="momthera_dashboard_box1">
                <div className="momthera_dashboard_box1_item">
                    <span style={{fontWeight: '800'}}>전체 사용자</span>
                    <span style={{fontWeight: '800'}}>{userData.TOTAL}</span>
                </div>
                <div className="momthera_dashboard_box1_item">
                    <span>실험군</span>
                    <span>{userData.EXP}</span>
                </div>
                <div className="momthera_dashboard_box1_item">
                    <span>대조군</span>
                    <span>{userData.COMP}</span>
                </div>
                <div className="momthera_dashboard_box1_item">
                    <span>테스터</span>
                    <span>{userData.TESTER}</span>
                </div>
                <div className="momthera_dashboard_box1_item">
                    <span>일반</span>
                    <span>{userData.COMMON}</span>
                </div>
            </div>
            <div className="dashboardContent__title">
                <span className="dashboardContent__title__content">
                어플 사용 현황
                </span>
            </div>
            <div className="momthera_dashboard_box2">
                <div className="momthera_dashboard_box2_graph_wrapper">
                    {usageGraphData.map(item=>(
                        <div key={item.code} className="momthera_dashboard_box2_graph_item">
                            <div className="momthera_dashboard_box2_graph_item_content">
                                <div className="title">{item.name}</div>
                                <div className="momthera_dashboard_box2_graph">
                                    <DashboardDoughnutChart data={item} color={item.patientGroupList.map(e=>COLOR[e.code])} />
                                    <div className="total_cnt">{item.count}</div>
                                </div>                                
                            </div>
                            <div className="legend">
                                {item.patientGroupList.map(groupItem => (
                                    <div key={groupItem.code} className="legend_item">
                                        <div className="legend_color" style={{backgroundColor: COLOR[groupItem.code]}} />
                                        <span>{groupItem.name}</span>
                                        <span>({groupItem.rate}%)</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}                   
                </div>
                <div className="momthera_dashboard_box2_table_wrapper">
                    <MomtheraCommonTable
                        type="dashboard"
                        tableHeader={['현황','count','percentage']}
                        tableBody={usageTableData}
                    />
                </div>
            </div>
        </div>
    );
}

export default MomtheraDashboardPage;